import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MainContext from "./contexts/main";
import * as authApi from "api/auth";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MainLayout from "./layouts/main";
import PanelLayout from "./layouts/panel";
import RequireAuth from "./layouts/requireAuth";
import WithoutAuth from "./layouts/withoutAuth";
import Home from "./pages/home";
import Auth from "./pages/auth";
import PasswordReset from "./pages/passwordReset";
import Policy from "./pages/policy";
import Circulars from "./pages/circulars";
import Sell from "./pages/sell";
import Modal from "components/modal";
import Button from "components/button";
import ProfilePage from "pages/profile";
import OrdersPage from "pages/orders";
import SecondPayment from "pages/secondPayment";
import CustomerFinancesPage from "pages/customerFinancesPage";
import StockPage from "pages/stock";
import UploadPage from "./pages/upload";

function App() {
  const [state, dispatch] = React.useReducer(
    (state, action) => {
      switch (action.type) {
        case "SET_USER":
          return { ...state, user: action.payload, logOutConfirm: false };
        case "SET_INFORMATION":
          return {
            ...state,
            user: {
              ...state.user,
              profile: { ...state.user.profile, information: action.payload },
            },
          };
        case "lOGOUT_CONFIRM":
          return {
            ...state,
            logOutConfirm: action.payload,
          };
        default:
          return state;
      }
    },
    { user: null, logOutConfirm: false }
  );
  const logout = async () => {
    await authApi.logout().then(() => {
      localStorage.removeItem("token");
      dispatch({ type: "SET_USER", payload: null });
    });
  };
  const mainContextData = {
    user: state.user,
    setUser: (user) => dispatch({ type: "SET_USER", payload: user }),
    setInformation: (information) => {
      dispatch({ type: "SET_INFORMATION", payload: information });
    },
    logOut: () => {
      dispatch({ type: "lOGOUT_CONFIRM", payload: true });
    },
  };
  return (
    <MainContext.Provider value={mainContextData}>
      <Modal
        status={state.logOutConfirm}
        close={() => dispatch({ type: "lOGOUT_CONFIRM", payload: false })}
      >
        <div className="modal-body">
          <div className="modal-message">مطمئن هستید؟</div>
          <div className="modal-buttons">
            <Button
              title="خیر"
              btn="outline"
              onClick={() =>
                dispatch({ type: "lOGOUT_CONFIRM", payload: false })
              }
            />
            <Button title="تایید" onClick={logout} />
          </div>
        </div>
      </Modal>
      <BrowserRouter>
        <MainLayout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route
              path="/auth"
              element={
                <WithoutAuth>
                  <Auth />
                </WithoutAuth>
              }
            />
            <Route
              path="/change-password"
              element={
                <RequireAuth>
                  <PanelLayout>
                    <PasswordReset />
                  </PanelLayout>
                </RequireAuth>
              }
            />
            <Route path="/policy" element={<Policy />} />
            <Route path="/circulars" element={<Circulars />} />
            <Route
              path="/sell"
              element={
                <RequireAuth>
                  <Sell />
                </RequireAuth>
              }
            />
            <Route
              path="/profile"
              element={
                <RequireAuth>
                  <PanelLayout>
                    <ProfilePage />
                  </PanelLayout>
                </RequireAuth>
              }
            />
            <Route
              path="/orders"
              element={
                <RequireAuth>
                  <PanelLayout>
                    <OrdersPage />
                  </PanelLayout>
                </RequireAuth>
              }
            />
            <Route
              path="/customer-finances"
              element={
                <RequireAuth>
                  <PanelLayout>
                    <CustomerFinancesPage />
                  </PanelLayout>
                </RequireAuth>
              }
            />
            <Route
              path="/second-payment"
              element={
                <RequireAuth>
                  <PanelLayout>
                    <SecondPayment />
                  </PanelLayout>
                </RequireAuth>
              }
            />
            <Route
              path="/stock"
              element={
                <RequireAuth>
                  <PanelLayout>
                    <StockPage />
                  </PanelLayout>
                </RequireAuth>
              }
            />
            <Route
                path="/upload-document"
                element={
                  <RequireAuth>
                    <PanelLayout>
                      <UploadPage />
                    </PanelLayout>
                  </RequireAuth>
                }
            />
          </Routes>
          <ToastContainer
            position="top-left"
            autoClose={5000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </MainLayout>
      </BrowserRouter>
    </MainContext.Provider>
  );
}

export default App;
